import { render, staticRenderFns } from "./loading-unloading-inquiry.vue?vue&type=template&id=66055236&scoped=true&"
import script from "./loading-unloading-inquiry.vue?vue&type=script&lang=js&"
export * from "./loading-unloading-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66055236",
  null
  
)

export default component.exports